export const INITIAL_STATE = {
  user: null,
  session: null,
  tokens: null,
  loginTimeStamp: null,

  userRole: null,
  loginLoading: false,
  loginSuccess: null,
  loginFailure: null,

  verifyOktaAccountCreation: false,
  username: null,
  password: null,

  loginAuthLoading: false,
  loginAuthSuccess: null,
  loginAuthFailure: null,

  loginHerokuLoading: false,
  loginHerokuSuccess: null,
  loginHerokuFailure: null,

  setupBiometricsConsent: false,

  loginWithTokenLoading: false,
  loginWithTokenSuccess: null,
  loginWithTokenFailure: null,

  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: null,

  loginWithProxyPdnLoading: false,
  loginWithProxyPdnSuccess: null,
  loginWithProxyPdnFailure: null,

  registerLoading: false,
  registerSuccess: null,
  registerFailure: null,

  saveSignUp: null,
  saveCreateProfile: null,

  logoutLoading: false,
  logoutTimeout: false,
  logoutSuccess: null,
  logoutFailure: null,

  getSessionLoading: false,
  getSessionSuccess: null,
  getSessionFailure: null,

  getSessionUserLoading: false,
  getSessionUserSuccess: null,
  getSessionUserFailure: null,

  getLoggedInUserLoading: false,
  getLoggedInUserSuccess: null,
  getLoggedInUserFailure: null,

  sessionRefreshLoading: false,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: null,

  verifyEmailLoading: false,
  verifyEmailSuccess: null,
  verifyEmailFailure: null,

  changeDefaultCenterLoading: false,
  changeDefaultCenterSuccess: null,
  changeDefaultCenterFailure: null,

  updateAccountSettingLoading: false,
  updateAccountSettingSuccess: null,
  updateAccountSettingFailure: null,

  mergeAccountSettingLoading: false,
  mergeAccountSettingSuccess: null,
  mergeAccountSettingFailure: null,

  resendVerificationLoading: false,
  resendVerificationSuccess: null,
  resendVerificationFailure: null,

  resetPasswordLoading: false,
  resetPasswordSuccess: null,
  resetPasswordFailure: null,

  resetPassword2Loading: false,
  resetPassword2Success: null,
  resetPassword2Failure: null,

  resetPassword3Loading: false,
  resetPassword3Success: null,
  resetPassword3Failure: null,

  setupNewPasswordLoading: false,
  setupNewPasswordSuccess: null,
  setupNewPasswordFailure: null,

  verifyOktaAccountLoading: false,
  verifyOktaAccountSuccess: null,
  verifyOktaAccountFailure: null,

  userNotifications: null,

  enrollMfaLoading: false,
  enrollMfaSuccess: null,
  enrollMfaFailure: null,

  resendEnrollMfaCodeLoading: false,
  resendEnrollMfaCodeSuccess: null,
  resendEnrollMfaCodeFailure: null,

  sendMfaCodeLoading: false,
  sendMfaCodeSuccess: null,
  sendMfaCodeFailure: null,

  verifyMfaCodeLoading: false,
  verifyMfaCodeSuccess: null,
  verifyMfaCodeFailure: null,

  getEnrolledMfaListLoading: false,
  getEnrolledMfaListSuccess: null,
  getEnrolledMfaListFailure: null,

  authenticateMfaCodeLoading: false,
  authenticateMfaCodeSuccess: null,
  authenticateMfaCodeFailure: null,
};
